// SEO helpers shared by public pages.

// Collapses whitespace and trims copy to a clean meta-description length.
export const metaDescription = (text, max = 160) => {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(" ") > 60 ? cut.lastIndexOf(" ") : cut.length)}…`;
};

// Picks the admin-written SEO description when present, else derives one.
export const seoDesc = (doc, bodyKey = "description") =>
  (doc?.seo_description || "").trim() || metaDescription(doc?.[bodyKey]);
